/* eslint-disable */
import { useProgramme } from "@components/__templates__/ProgrammeDetailsPage/ProgrammeDetailsProvider";
import Cta from "@components/Cta/Cta";
import Grid from "@components/Grid/Grid";
import { TypeProgrammeDetailsBarFields } from "@customTypes/contentful";
import { ProgrammeDetailsBarSettings } from "@customTypes/programmeDetailsBarSettings";
import { ProgrammeHybridOfferings } from "@customTypes/programmeHybridOfferings";
import { ProgrammeImportData } from "@customTypes/programmeImportData";
import { useApplicationLink } from "@utilities/applicationLinkHelper";
import { useSettings } from "@utilities/context/settings";
import { fetchApi } from "@utilities/fetchApi";
import { useDevice } from "@utilities/react/get-device/get-device";
import clsx from "clsx";
import { useRouter } from "next/router";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Pagination } from "swiper/modules";
import { Swiper as Slider, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/pagination";
import { useProgrammeDetailsPage } from "../../context/programmeDetailsPage";
import { UserContext } from "../../context/user";
import DownloadTypes from "../../types/DownloadTypes";
import styles from "./C72.1_ProgrammeDetailsBar.module.scss";

export interface ProgrammeDetailsBarProps {
  content: {
    fields: TypeProgrammeDetailsBarFields;
  };
  isSticky?: boolean;
}

const ProgrammeDetailsBar = (props: ProgrammeDetailsBarProps) => {
  const { content, isSticky } = props;

  const { importDataProgrammeTypeCode } = useProgramme();
  const { siteSettings } = useSettings();
  const { programmeApplyOnlineParameterValue, type, applicationInSalesforce } =
    useProgrammeDetailsPage();

  const { programmeTypeCode, programmeTypeGroup } = useProgramme();
  const downloadBrochureSlug =
    siteSettings?.programmeCtaPagesCollection?.items.find(
      (item) =>
        item.type.toLowerCase() ===
        DownloadTypes.DOWNLOAD_BROCHURE.toLowerCase()
    );

  if (!content.fields) return;

  const device = useDevice();

  const {
    fields: {
      tertiaryCtaLink,
      ctaLink1,
      ctaLink2,
      showDownloadCta,
      showApplyNowCta,
      helpText,
      isSecondVariation,
      programmeEnrichmentData,
    },
  } = content;

  const mapHybridOfferings = () => {
    if (isSecondVariation) {
      return programmeEnrichmentData?.map((overrideData) => {
        let date = overrideData?.fields?.progDetailBarDate.split(";");
        let location = overrideData?.fields?.progDetailBarLocation.split(";");
        let duration = overrideData?.fields?.progDetailBarDuration.split(";");
        let availability = overrideData?.fields?.programmeAvailability;
        let arr: [{}] = [{}];
        arr.shift();
        for (let i = 0; i < date.length; i++) {
          arr.push({
            ProgrammeInclusiveDates: "Module " + (i + 1) + ": " + date[i],
            ProgrammeDuration: duration[i],
            ProgrammeLocation: location[i],
            programmeAvailabilityString: availability ? availability[i] : "",
          });
        }
        return arr;
      });
    }
  };

  const programmeHybridOfferings = mapHybridOfferings();

  const [programmeImportData, setProgrammeImportData] = useState<
    ProgrammeImportData[]
  >([]);

  const [programmeDetailsBarSettings, setProgrammeDetailsBarSettings] =
    useState<ProgrammeDetailsBarSettings>();

  useEffect(() => {
    const getData = async () => {
      const programmeBarData = await fetchApi(
        "/api/getProgrammeDetailsBarData",
        {
          typeCodes: importDataProgrammeTypeCode,
        }
      );

      setProgrammeImportData(programmeBarData.programmeImportDataCollection);
      setProgrammeDetailsBarSettings(
        programmeBarData.programmeDetailsBarSettings
      );
    };
    getData();
  }, [importDataProgrammeTypeCode]);

  const checkIfSameLocationAndDuration = () => {
    let count = 0;
    programmeImportData.forEach((item) => {
      if (
        item.programmeDuration === programmeImportData[0].programmeDuration &&
        item.programmeLocation === programmeImportData[0].programmeLocation
      ) {
        count++;
      }
    });
    return count === programmeImportData.length;
  };

  const isSameLocationAndDuration = checkIfSameLocationAndDuration();

  const detailsBarRef = useRef<HTMLDivElement>(null);
  const optionWrapperRef = useRef<HTMLDivElement>(null);
  const optionsRef = useRef<HTMLDivElement>(null);

  const [showOptions, setShowOptions] = useState(false);
  const [showSessions, setShowSessions] = useState(false);
  const { user } = useContext(UserContext);
  const router = useRouter();
  const applyNowUrl = useApplicationLink({
    user: !!user,
    programmeApplyOnlineId: programmeApplyOnlineParameterValue,
    isSalesforceApplication: applicationInSalesforce,
  });
  const [referPage, setReferPage] = useState("");
  useEffect(() => {
    setReferPage(router.asPath);
  }, [router]);

  useEffect(() => {
    if (isSticky) {
      setShowOptions(false);
      setShowSessions(false);
    }
  }, [isSticky]);

  useEffect(() => {
    if (isSticky && !showSessions) {
      setShowOptions(false);
    }
  }, [isSticky, showOptions, showSessions]);

  useEffect(() => {
    if (optionsRef.current) {
      if (showOptions) {
        let height = optionWrapperRef?.current?.offsetHeight;
        if (height > 400) {
          height = 400;
        }
        optionsRef.current.style.height = height + "px";
      } else {
        optionsRef.current.style.height = "0px";
      }
    }
  }, [showOptions]);

  const onSelectContainerClick = () => {
    if (programmeImportData.length <= 1) {
      return;
    }
    setShowOptions(!showOptions);
  };

  const onSelectContainerKeyPress = (e) => {
    if (programmeImportData.length <= 1) {
      return;
    }
    if (e.key === "Enter" || e.key === " ") {
      setShowOptions(!showOptions);
    }
  };

  const onToggleSessionsClick = (e) => {
    e.preventDefault();
    setShowSessions(!showSessions);

    setTimeout(() => {
      setShowOptions(!showOptions);
    }, 100);
  };

  const onToggleMoreSessionsClick = (e) => {
    e.preventDefault();

    setShowOptions(!showOptions);
  };

  const onMobileTogglerClick = (e) => {
    e.preventDefault();
    setShowSessions(!showSessions);
  };

  const optionsVisibility = () => {
    if (isSticky) {
      if (showSessions) {
        return showSessions;
      }
      return false;
    }
    return true;
  };

  const hybridDesktopJSX = (index) => (
    <div
      className={clsx(styles["data-second-variant"], styles["desktop-only"])}
    >
      {programmeHybridOfferings
        .slice(1)
        [index]?.map((offering: ProgrammeHybridOfferings, i) => (
          <div
            key={`${offering.ProgrammeInclusiveDates}${offering.ProgrammeDuration}${i}`}
          >
            <p>
              <span className={styles.title}>Dates</span>
              <span className={styles.value}>
                {offering.ProgrammeInclusiveDates}
              </span>
            </p>
            <p>
              <span className={styles.title}>Duration</span>
              <span className={styles.value}>{offering.ProgrammeDuration}</span>
            </p>
            <p>
              <span className={styles.title}>Format</span>
              <span className={styles.value}>{offering.ProgrammeLocation}</span>
            </p>
          </div>
        ))}
      <div>
        <p className={styles["smallText"]}>
          {programmeDetailsBarSettings?.allModuleSameCourseLabelEe
            ? programmeDetailsBarSettings.allModuleSameCourseLabelEe.replace(
                "?",
                programmeHybridOfferings.slice(1)[index]?.length.toString()
              )
            : ""}
        </p>
      </div>
    </div>
  );

  const hybridMobileJSX = (i) => (
    <div className={clsx(styles["data-second-variant"], styles.mobile)}>
      {programmeHybridOfferings[i]?.map(
        (offering: ProgrammeHybridOfferings, index) => (
          <Fragment key={`${index}`}>
            <p className={styles["module-paragraph"]}>
              {offering.ProgrammeInclusiveDates}
            </p>
            <p className={styles["inner-border"]}>
              <span className={styles.title}>Duration</span>
              {offering.ProgrammeDuration}
            </p>
            <p className={styles["inner-border"]}>
              <span className={styles.title}>Format</span>
              {offering.ProgrammeLocation}
            </p>
          </Fragment>
        )
      )}

      <div>
        <p className={styles.smallText}>
          {programmeDetailsBarSettings?.allModuleSameCourseLabelEe
            ? programmeDetailsBarSettings.allModuleSameCourseLabelEe.replace(
                "?",
                programmeHybridOfferings?.slice(1)[i]?.length.toString()
              )
            : ""}
        </p>
      </div>
    </div>
  );

  const programmeDataLookUp = isSecondVariation
    ? device === "mobile"
      ? programmeHybridOfferings
      : programmeHybridOfferings.slice(1)
    : device === "mobile"
      ? programmeImportData
      : programmeImportData.slice(1);

  const sliderSettings = {
    slidesPerView: 1,
    allowTouchMove: true,
    pagination: {
      clickable: true,
    },
    loop: programmeDataLookUp.length > 1,
    modules: [Pagination],
    speed: 500,
  };

  return programmeImportData.length ? (
    <div
      ref={detailsBarRef}
      className={clsx(
        styles.component,
        styles["programme-details-bar"],
        styles.two,
        (showSessions || showOptions) && styles.show,
        programmeImportData.length <= 1 && styles["single-option"],
        isSticky && device === "mobile" && styles["sticky-mobile"]
      )}
    >
      <div
        className={clsx(
          styles.wrapper,
          isSticky && device !== "mobile" && styles.sticky,
          isSticky && device === "mobile" && styles["sticky-mobile"],
          "wrapper"
        )}
      >
        <div
          onClick={onToggleSessionsClick}
          className={clsx(
            styles["toggle_available_sessions"],
            showSessions && styles.sessionsOpen
          )}
          id="toggle_available_sessions"
        >
          <a
            className={styles["toggle-link-for-available-sessions"]}
            href=""
            aria-expanded={showSessions ? "true" : "false"}
          >
            {programmeDetailsBarSettings?.stickyToggleTextEe}
          </a>
        </div>
        {optionsVisibility() && (
          <div className={styles["row-middle"]}>
            <Grid row>
              <Grid column lg={9} sm={12}>
                <div className={styles["select-container"]}>
                  <div className={styles.headers}>
                    <p className="">Dates</p>
                    <p className="">Duration</p>
                    <p className="">Format</p>
                  </div>
                  <div
                    onClick={onSelectContainerClick}
                    onKeyDown={onSelectContainerKeyPress}
                    className={styles.select}
                    tabIndex={0}
                    role="combobox"
                    aria-expanded={showOptions ? "true" : "false"}
                    aria-owns="details-select-box"
                    aria-haspopup="listbox"
                  >
                    {programmeImportData && (
                      <>
                        {isSecondVariation ? (
                          <div
                            id="selection"
                            className={styles["selection-second-variant"]}
                            tabIndex={-1}
                          >
                            {programmeHybridOfferings[0]?.map(
                              (programmeData: ProgrammeHybridOfferings, i) => (
                                <div
                                  key={`${programmeData.ProgrammeInclusiveDates}${programmeData.ProgrammeDuration}${i}`}
                                >
                                  <p>{programmeData.ProgrammeInclusiveDates}</p>
                                  <p>{programmeData.ProgrammeDuration}</p>
                                  <p>{programmeData.ProgrammeLocation}</p>
                                </div>
                              )
                            )}
                            <p className={styles.smallText}>
                              {programmeDetailsBarSettings?.allModuleSameCourseLabelEe
                                ? programmeDetailsBarSettings.allModuleSameCourseLabelEe.replace(
                                    "?",
                                    programmeHybridOfferings[0]?.length.toString()
                                  )
                                : ""}
                            </p>
                          </div>
                        ) : (
                          <div>
                            <div
                              id="selection"
                              className={styles["selection"]}
                              tabIndex={-1}
                            >
                              <p className={styles.hybrid}>
                                {programmeImportData[0] &&
                                  programmeImportData[0]
                                    .programmeInclusiveDates}
                              </p>
                              <p className={styles.hybrid}>
                                {programmeImportData[0]?.programmeDuration}
                              </p>
                              <p className={styles.hybrid}>
                                {programmeImportData[0]?.programmeLocation}
                              </p>
                              <p></p>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {programmeImportData && programmeImportData.length > 1 && (
                    <div className={styles.accordioneed}>
                      <button
                        onClick={onToggleMoreSessionsClick}
                        id="toggle_more_sessions"
                        className={styles["toggle-link"]}
                        aria-expanded={showOptions ? "true" : "false"}
                        aria-controls="details-select-box"
                      >
                        {!showOptions
                          ? isSameLocationAndDuration
                            ? programmeDetailsBarSettings?.toggleLinkTextPlusEe
                            : programmeDetailsBarSettings?.longToggleLinkTextPlusEe
                          : isSameLocationAndDuration
                            ? programmeDetailsBarSettings?.toggleLinkTextMinusEe
                            : programmeDetailsBarSettings?.longToggleLinkTextMinusEe}
                        <p className="toggle-link-plus-text">
                          {isSameLocationAndDuration
                            ? programmeDetailsBarSettings?.toggleLinkTextPlusEe
                            : programmeDetailsBarSettings?.longToggleLinkTextPlusEe}
                        </p>
                        <p className="toggle-link-minus-text">
                          {isSameLocationAndDuration
                            ? programmeDetailsBarSettings?.toggleLinkTextMinusEe
                            : programmeDetailsBarSettings?.longToggleLinkTextMinusEe}
                        </p>
                        <p className="sticky-toggle-text">
                          {programmeDetailsBarSettings?.stickyToggleTextEe}
                        </p>
                      </button>
                    </div>
                  )}
                </div>
              </Grid>
              <Grid column lg={3} sm={12}>
                <div className={styles.buttons}>
                  {tertiaryCtaLink && (
                    <Cta
                      linkText={tertiaryCtaLink?.fields?.linkText}
                      type="tertiary"
                      url={tertiaryCtaLink?.fields?.url}
                      icon="icon-arrow"
                      light
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
      <div
        onClick={onMobileTogglerClick}
        className={clsx(
          styles["mobile-toggler"],
          isSticky && device === "mobile" && styles["sticky-mobile"]
        )}
      >
        {programmeDetailsBarSettings?.stickyToggleTextEe}
        <div className={clsx(styles.tick, styles["icon-chevron"])}>
          <svg
            height="20"
            width="20"
            viewBox="0 0 8 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
          >
            <path d="M2 0L.59 1.41 5.17 6 .59 10.59 2 12l6-6z"></path>
          </svg>
        </div>
      </div>
      <div
        className={clsx(
          styles.options,
          isSticky && device !== styles.mobile && styles.sticky,
          !optionsVisibility() && styles.hide
        )}
        ref={optionsRef}
      >
        <div ref={optionWrapperRef} className={clsx(styles.optionsWrapper)}>
          <div className={styles.row}>
            <Grid row>
              <Grid column sm={12} md={12}>
                <div
                  className={styles.container}
                  role="listbox"
                  id="details-select-box"
                  aria-labelledby="toggle_more_sessions"
                >
                  {device === "mobile" ? (
                    <>
                      <Slider {...sliderSettings}>
                        {programmeImportData &&
                          programmeDataLookUp.map((item, i) => (
                            <SwiperSlide
                              key={`${JSON.stringify(item)}${i}`}
                              className={styles.option}
                              data-href={`?id=${i}`}
                              tabIndex={0}
                            >
                              <Grid row>
                                <Grid column md={9} sm={12}>
                                  <div className={styles["option-inner"]}>
                                    {isSecondVariation ? (
                                      hybridMobileJSX(i)
                                    ) : (
                                      <div
                                        className={clsx(
                                          styles.data,
                                          styles.mobile
                                        )}
                                      >
                                        <p>
                                          <span className={styles.title}>
                                            Dates
                                          </span>
                                          <span
                                            className={styles["value-mobile"]}
                                          >
                                            {item.programmeInclusiveDates}
                                          </span>
                                        </p>
                                        <p className={styles["inner-border"]}>
                                          <span className={styles.title}>
                                            Duration
                                          </span>
                                          <span
                                            className={styles["value-mobile"]}
                                          >
                                            {item.programmeDuration}
                                          </span>
                                        </p>
                                        <p className={styles["inner-border"]}>
                                          <span className={styles.title}>
                                            Format
                                          </span>
                                          <span
                                            className={styles["value-mobile"]}
                                          >
                                            {item.programmeLocation}
                                          </span>
                                        </p>
                                      </div>
                                    )}
                                    <div className={styles.buttons}>
                                      {showApplyNowCta ? (
                                        <Cta
                                          linkText="Apply now"
                                          type="secondary"
                                          url={applyNowUrl}
                                          light
                                        />
                                      ) : (
                                        <>
                                          {ctaLink1 && (
                                            // @ts-expect-error type mismatch
                                            <Cta
                                              {...ctaLink1.fields}
                                              type="primary"
                                              light
                                            />
                                          )}
                                        </>
                                      )}
                                      {showDownloadCta ? (
                                        <Cta
                                          linkText="Download brochure"
                                          type="tertiary"
                                          url={`${downloadBrochureSlug?.url.slug}?programmeTypeCode=${programmeTypeCode}&programmeTypeGroup=${programmeTypeGroup}&programType=${type}&brochureType=Download a brochure&referPage=${referPage}`}
                                          light
                                          icon="icon-download"
                                        />
                                      ) : (
                                        <>
                                          {ctaLink2 && (
                                            // @ts-expect-error type mismatch
                                            <Cta
                                              {...ctaLink2.fields}
                                              type="tertiary"
                                              light
                                              icon="icon-arrow"
                                            />
                                          )}
                                        </>
                                      )}

                                      {helpText && (
                                        <Cta
                                          url=""
                                          linkText=" "
                                          type="tertiary"
                                          helpText={helpText}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </SwiperSlide>
                          ))}
                      </Slider>
                    </>
                  ) : (
                    <>
                      {programmeDataLookUp &&
                        programmeDataLookUp.map((item, index) => (
                          <div
                            key={`${JSON.stringify(item)}${index}`}
                            className={clsx(
                              styles.option,
                              index === programmeDataLookUp.length - 1 &&
                                styles["last-option"],
                              !isSameLocationAndDuration && styles.notsame
                            )}
                            data-href={`?id=${index}`}
                            tabIndex={0}
                          >
                            <Grid row>
                              <Grid column lg={9} md={12} sm={12}>
                                <div className={styles["option-inner"]}>
                                  {isSecondVariation ? (
                                    hybridDesktopJSX(index)
                                  ) : (
                                    <div className={styles["data"]}>
                                      <p className={styles.hybrid}>
                                        <span className={styles.title}>
                                          Dates
                                        </span>
                                        <span className={styles.value}>
                                          {item.programmeInclusiveDates}
                                        </span>
                                      </p>
                                      {(isSameLocationAndDuration &&
                                        index === 0) ||
                                        (!isSameLocationAndDuration && (
                                          <>
                                            <p className={styles.hybrid}>
                                              <span className={styles.title}>
                                                Duration
                                              </span>
                                              <span className={styles.value}>
                                                {item.programmeDuration}
                                              </span>
                                            </p>
                                            <p className={styles.hybrid}>
                                              <span className={styles.title}>
                                                {isSameLocationAndDuration
                                                  ? "Location"
                                                  : "Format"}
                                              </span>
                                              <span className={styles.value}>
                                                {item.programmeLocation}
                                              </span>
                                            </p>
                                          </>
                                        ))}
                                    </div>
                                  )}
                                  <>
                                    {item.programmeAvailabilityString && (
                                      <div className={styles.availability}>
                                        <p>
                                          {item.programmeAvailabilityString}
                                        </p>
                                      </div>
                                    )}
                                    <div className={styles.buttons}>
                                      {showApplyNowCta ? (
                                        <Cta
                                          linkText="Apply now"
                                          type="secondary"
                                          url={applyNowUrl}
                                          light
                                        />
                                      ) : (
                                        <>
                                          {ctaLink1 && (
                                            // @ts-expect-error type mismatch
                                            <Cta
                                              {...ctaLink1.fields}
                                              type="primary"
                                              light
                                            />
                                          )}
                                        </>
                                      )}
                                      {false && showDownloadCta ? (
                                        //  && showDownloadCta to be added
                                        //Work related to this will be covered in another ticket
                                        <Cta
                                          linkText="Download brochure"
                                          type="tertiary"
                                          //  showDownloadCta to be decided on the integration
                                          url={"#ApplyLink"}
                                          light
                                          icon="icon-download"
                                        />
                                      ) : (
                                        <>
                                          {ctaLink2 && (
                                            // @ts-expect-error type mismatch
                                            <Cta
                                              {...ctaLink2.fields}
                                              type="tertiary"
                                              light
                                              icon="icon-arrow"
                                            />
                                          )}
                                        </>
                                      )}

                                      {helpText && (
                                        <Cta
                                          url=""
                                          linkText=" "
                                          type="tertiary"
                                          helpText={helpText}
                                        />
                                      )}
                                    </div>
                                  </>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        ))}
                    </>
                  )}
                </div>
                <div className={styles["link-switch"]}>
                  {tertiaryCtaLink && (
                    <Cta
                      linkText={tertiaryCtaLink?.fields?.linkText}
                      type="tertiary"
                      url={tertiaryCtaLink?.fields?.url}
                      icon="icon-arrow"
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ProgrammeDetailsBar;
